// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__5n3ez","modal":"InfoModal_modal__l4-+h","btn_main":"InfoModal_btn_main__jdgjq"};